/* ---------------------------------------------------------------------------------------------------------------------
ACF CONTAINERS FIELD TYPE JS
--------------------------------------------------------------------------------------------------------------------- */
(function($) {
    acf.addAction('ready', function () {
        var $product = $('#post');
        $('.acf-containers-field').each(function () {
            var $this = $(this),
                $tbody = $this.find('tbody'),
                $clone = $this.find('tr.dummy-row').clone().removeClass('dummy-row'),
                name = $this.data('name'), rows = $this.data('rows');

            // Add container helper function
            function add_container(i, product_id, id, customer_link = '', stock_status = 'instock', subscription_link = '', customer_email = '', variations, disabled = false) {

                var $container = $clone.clone();


                $container.find('[name=product_id]').attr('value', product_id).attr('name', name + '[' + i + '][product_id]');
                $container.find('[name=container_id]').attr('value', id).attr('name', name + '[' + i + '][container_id]').attr('placeholder', 'Enter Container Id').attr('readonly', disabled);
                $container.find('[name=container_variations]').attr('value', variations).attr('name', name + '[' + i + '][container_variations]').attr('placeholder', 'Enter Container Number');
                $container.find('select[name=stock_status]').val(stock_status).attr('name', name + '[' + i + '][stock_status]').val(stock_status).prop('disabled', stock_status === 'outofstock' && subscription_link.length > 0);
                $container.find('.customer_email').html( customer_email.length > 0 ? jQuery.parseJSON(customer_email) : '');
                $container.find('.customer_link').html( customer_link.length > 0 ? jQuery.parseJSON(customer_link) : '');
                $container.find('.subscription_link').html( subscription_link.length > 0 ? jQuery.parseJSON(subscription_link) : '');
                $tbody.append($container);

                // Remove container button action
                $tbody.find('tr:not(.dummy-row)').eq(i - 1).find("[data-action='remove-container']").click(function (e) {
                    $(this).closest('tr').remove();
                    e.preventDefault();
                });
            }

            // Add existing container rows
            $.each(rows, function (i, row) {

                console.log(row);

                add_container(i, row.product_id, row.container_id, row.customer_link, row.stock_status, row.subscription_link, row.customer_email, row.variation_ids,true);
            });

            // Add container button action
            $("[data-action='add-container']").click(function (e) {
                add_container($tbody.find('tr:not(.dummy-row)').length + 1);
                e.preventDefault();
            });

            // Remove container button action
            $("[data-action='remove-container']").click(function (e) {

                var $this = $(this),
                    $container = $this.closest('tr'),
                    index = $container.index() > 1 ? $container.index() - 1 : 0,
                    product_id = $container.find('input[name="' + name + '[' + index + '][product_id]'+'"]').val();

                if (product_id.length > 0) {
                    if (confirm("Are you sure you want to delete this container?")) {
                        $.ajax({
                            url: containers_field.url,
                            type: "POST",
                            data: {
                                'action': 'acf_remove_container_action',
                                'nonce': containers_field.nonce,
                                'product_id': product_id
                            },
                            dataType: "json",
                        }).done(function(response) {
                            if (response.error && response.success === 0) {
                                $('html, body').animate({scrollTop: 0});
                                var error = response.error;
                                if ($('.acf-notice').text() === error) return;
                                $product.before('<div class="acf-notice -error acf-error-message"><p>' + error + '</p></div>');
                            } else {
                                $this.closest('tr').remove();
                            }
                        });
                    }
                }
                e.preventDefault();
            });
        });
    });
})(jQuery);
